import { Container, IDestroyOptions, ObservablePoint } from "pixi.js";
import { MyBuildingsTutorialResourcePackage } from "../../resources/MyBuildingsTutorialResourcePackage";
import { MyBuildingsTutorialTooltipComponent } from "./MyBuildingsTutorialTooltipComponent";
import { Hand } from "../../../../common/components/Hand";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import gsap from "gsap";
import { SoundsResourcePackageWrapper } from "by/gamefactory/cityversetycoon/scenes/common/resources/SoundsResourcePackageWrapper";
type Timeline = gsap.core.Timeline;

export class MyBuildingsTutorial extends Container {
    private static readonly ANIMATION_TIME = 0.6;
    private static readonly HAND_DEFAULT_POS_X = 430;
    private static readonly HAND_DEFAULT_POS_Y = 570;
    private static readonly HAND_DEFAULT_ANGLE = -30;
    private static readonly HAND_START_POS_X = 450;
    private static readonly HAND_START_POS_Y = 1470;
    private static readonly HAND_START_ANGLE = -110;

    private readonly tutorialResources: MyBuildingsTutorialResourcePackage;
    private readonly commonResources: CommonResourcesPackage;
    private readonly soundResources: SoundsResourcePackageWrapper;

    private hand: Hand;
    private handScale: ObservablePoint;
    private tooltipComponent: MyBuildingsTutorialTooltipComponent;
    private timeline: Timeline;

    public constructor(
        tutorialResources: MyBuildingsTutorialResourcePackage,
        commonResources: CommonResourcesPackage,
        soundResources: SoundsResourcePackageWrapper
    ) {
        super();
        this.tutorialResources = tutorialResources;
        this.commonResources = commonResources;
        this.soundResources = soundResources;
        this.build();
    }

    private build(): void {
        this.hand = new Hand(this.commonResources);
        this.hand.width = -431;
        this.hand.height = 487;
        this.addChild(this.hand);
        this.handScale = this.hand.scale.clone();
        this.tooltipComponent = new MyBuildingsTutorialTooltipComponent(this.tutorialResources);
        this.tooltipComponent.pivot.y = this.tooltipComponent.height;
        this.tooltipComponent.pivot.x = this.tooltipComponent.width * 0.18;
        this.tooltipComponent.position.set(97 + this.tooltipComponent.width * 0.18, 207 + this.tooltipComponent.height);
        this.addChild(this.tooltipComponent);
        this.timeline = new gsap.core.Timeline({ paused: true });
        this.createAnimation();
        this.hand.visible = false;
        this.tooltipComponent.visible = false;
    }

    private createAnimation(): void {
        const duration = MyBuildingsTutorial.ANIMATION_TIME;
        this.timeline.fromTo(this.tooltipComponent.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: duration, ease: "back.out(1)" }, "0");
        this.timeline.fromTo(this.hand,
            {
                x: MyBuildingsTutorial.HAND_START_POS_X,
                y: MyBuildingsTutorial.HAND_START_POS_Y,
                angle: MyBuildingsTutorial.HAND_START_ANGLE
            },
            {
                x: MyBuildingsTutorial.HAND_DEFAULT_POS_X,
                y: MyBuildingsTutorial.HAND_DEFAULT_POS_Y,
                angle: MyBuildingsTutorial.HAND_DEFAULT_ANGLE,
                duration: duration,
            }, "0");
        this.timeline.fromTo(this.hand.scale, { x: 0, y: 0 }, { x: this.handScale.x, y: this.handScale.y, duration: duration }, "0");
    }

    public async show(): Promise<void> {
        this.soundResources.assets_sounds_myBuildings_upgrade_info_single_general_in_mp3.play();
        this.soundResources.assets_sounds_hand_movemet_general_mp3.play();
        this.tooltipComponent.visible = true;
        this.hand.visible = true;
        await this.timeline.play();
    }

    public async hide(): Promise<void> {
        await this.timeline.reverse();
        this.tooltipComponent.visible = false;
        this.hand.visible = false;
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.timeline.kill();
        super.destroy(options);
    }
}